import Container from '../../../../core/components/atoms/Container';
import { EventPageHeader } from '../../../../core/components/atoms/EventPageHeader';
import { ButtonGroup } from '../../../../core/components/organism/ButtonGroup';
import { LiveExamsListTab } from '../../components/AprovaLive/LiveExamsListTab';
import { RecordedClassesTab } from '../../components/AprovaLive/RecordedClassesTab';
import { TimelineTab } from '../../components/AprovaLive/TimelineTab';
import { useAprovaLivePage } from '../../hooks/AprovaLive/useAprovaLivePage';

export default function ChallengePage() {
  const { tabsButtons, selectedTab } = useAprovaLivePage();
  
  return (
    <Container className='flex flex-col gap-xxl' type='hd'>
      <EventPageHeader
        title={'Desafio 60 dias'}
        subtitle={
          'programa que oferece aulas ao vivo divididas em três ciclos independentes (fundamentos, evolução e conclusão) ao longo do ano.'
        }
        buttonProps={{
          children: 'Acesse o guia do Desafio 60 dias',
          variant: 'text',
          onClick: () => {
            window.open(
              'https://storage.googleapis.com/aprovatotal-files/platform-storage-prod/EBOOK_Guia_Desafio_60_Dias.pdf',
              '_blank'
            );
          },
        }}
      />

      <ButtonGroup {...tabsButtons} />

      {selectedTab === 'cronograma' && <TimelineTab origin='challenge' />}
      {selectedTab === 'aulas-gravadas' && <RecordedClassesTab origin='challenge' />}
      {selectedTab === 'simulados' && <LiveExamsListTab origin='challenge' />}
    </Container>
  );
}
